<template>
  <modal name="payPriceModal" :adaptive="true" :width="600" height="auto" class="modal-style" :clickToClose="false">
    <div class="lp-modal-wrapper" style="background-color:#E9E9E9">
      <div v-if="step===1">
        <div style="font-weight:600;font-size:20px;color:#000000">결제 기능 추가 구매</div>
        <div class="flex-between" style="margin-top:28px">
          <div class="flex-align">
            <div class="tab-box unselect" :class="{'tab-selected':tab===0}"
                 @click="clickTab(0)">PG 결제</div>
            <div class="tab-box unselect" :class="{'tab-selected':tab===1}" style="margin-left:4px" @click="clickTab(1)">간편결제</div>
          </div>
          <div style="font-size:13px;color:#989898">*vat 별도</div>
        </div>
        <div style="margin-top:6px" v-if="selectedTab">
          <template v-for="(price, p_idx) in selectedTab.list">
            <div class="flex-between unselect" :class="{'price-selected': price.selected}"
                 :key="`p-${p_idx}`"
                 style="padding:17px 34px;border-radius:6px;background-color:white;margin-top:6px"
                 @click="clickItem(price)" v-if="price.enable">
              <div :class="{'primary': price.selected}" style="font-size:21px;color:#363636">{{ price.name }}</div>
              <div>
                <div style="color:#B6BECB;font-size:16px;text-decoration:line-through;text-align:right">{{
                  price.origin_price | currency }}
                </div>
                <div class="flex-align">
                  <div class="primary" style="font-size:18px">{{ price.discount }}%</div>
                  <div style="font-size:18px;margin-left:5px">{{ price.price | currency }}</div>
                </div>
              </div>
            </div>
          </template>

        </div>
        <div style="color:#363636;font-size:13px;font-weight:500;margin-top:12px">*계약 및 연동 작업에 2~3주 가량 소요될 수 있습니다.</div>

        <div class="btn-group-justify-end" style="margin-top:190px">
          <button class="button" style="background-color:#B6BECB;color:white" @click="cancel">취소하기</button>
          <button class="button is-primary" @click="nextStep">신청하기</button>
        </div>
      </div>
      <div v-else-if="step===2">
        <div style="font-weight:600;font-size:20px;color:#000000">PG결제 신청</div>
        <div style="padding:21px 23px;border-radius:6px;background-color:white;margin-top:23px">
          <div style="font-size:21px">{{ selectedItem.name }} 기능 추가 신청</div>
          <div style="margin-top:25px;font-size:13px;font-weight:bold">상품명</div>
          <div style="margin-top:8px;font-size:13px">{{ selectedItem.name }}</div>
          <div style="margin-top:8px;font-size:13px;font-weight:bold">결제금액</div>
          <div style="margin-top:8px;font-size:13px">{{ selectedItem.price | currency }}(vat 포함)</div>
          <div style="margin-top:8px;font-size:13px;font-weight:bold">결제방식</div>
          <lp-radio :val.sync="pay_method"
                    value_name="value"
                    label_name="label"
                    style="margin-top:8px"
                    :data="[{label:'카드결제',value:'Card'},{label:'실시간계좌이체',value:'DirectBank'},{label:'가상계좌',value:'VBank'}]"></lp-radio>
        </div>
        <div style="color:#363636;font-size:12px;font-weight:500;margin-top:12px">*결제 후 등록된 이메일 계정으로 PG 신청 매뉴얼이 안내됩니다.</div>

        <div class="btn-group-justify-end" style="margin-top:58px">
          <button class="button" style="background-color:#B6BECB;color:white" @click="cancel">취소하기</button>
          <button class="button is-primary" @click="openPg">결제하기</button>
        </div>
      </div>

      <iframe name="ifr" class="pg" :src="url" :style="containerStyle" v-if="showPgPopup"></iframe>
    </div>
  </modal>
</template>
<script>
  import LpRadio from "../../../module/common/LpRadio";
  export default {
    name: "PayPriceModal",
    components: {LpRadio},
    created() {
    },
    data() {
      return {
        step: 1,
        // 결제방식
        pay_method: 'DirectBank',
        service: undefined,
        showPgPopup: false,
        tab: 0,
        selectedTab: undefined,
        selectedItem: undefined,
        payPrice: [],
        list: [],
      }
    },
    mounted() {
      this.getServiceInfo();
      this.getData();
      this.$modal.show('payPriceModal');
    },
    computed: {
      url() {
        if (!this.showPgPopup) return;
        let domain = this.$store.getters.getServiceSetting.domain;
        // let domain = `http://localhost:8080`
        let returnUrl = `${domain}/office/admin/service/setting`;
        let pg_domain = 'https://plugin.launchpack.co.kr'
        // let pg_domain = 'http://localhost:8082'

        let goodname = this.selectedItem.name
        if(this.$store.getters.serviceName) {
          goodname += `(${this.$store.getters.serviceName})`
        }
        let url = `${pg_domain}/php/inicis/inicis/pay/lpBasicPayRequest.php`;
        url += `?price=${this.selectedItem.price}`;
        url += `&goodname=${goodname}`;
        url += `&buyername=${this.service.service_user.name}`;
        url += `&buyeremail=${this.service.service_user.email}`;
        url += `&buyertel=${this.service.service_user.phone}`;
        url += `&merchant_id=${this.merchant_id}`;
        url += `&gopaymethod=${this.pay_method}`;
        url += `&returnUrl=${returnUrl}`;
        url += `&merchant_id=${this.merchant_id}`
        return url;
        //return 'https://plugin.launchpack.co.kr/php/inicis/inicis/lpPayInfo.php?price=1000&service_key=junotest';
      },
      containerStyle() {
        return {
          position: 'fixed',
          zIndex: '10',
          top: '50%',
          left: '50%',
          width: '820px',
          transform: 'translate(-50%, -50%)',
          height: '600px',
          border: '0'
        }
      }
    },
    methods: {
      getServiceInfo() {
        this.$axios.get('https://master-dev.launchpack.co.kr:1111/public/launchpack/service/key/masters').then(res=>{
          this.service = res.data;
        })
      },
      getMerChantId() {
        this.$axios.post(`public/merchant`, {
          price: this.selectedItem.price,
          payinfo: this.selectedItem
        }).then(res => {
          if (res.status === 200) {
            this.merchant_id = res.data;
            this.$store.commit('setPayPriceMerchantId', res.data);
            this.showPgPopup = true;
          }
        })
      },
      clickTab(type) {
        this.tab = type;
        this.selectedTab = this.payPrice[type];
      },
      clickItem(price) {
        this.selectedTab.list.forEach(item=>{item.selected=false})
        price.selected = true;
        this.selectedItem = price;
      },
      nextStep() {
        if(!this.selectedItem) {
          this.toast('결제 방식을 선택해주세요.')
          return;
        }
        this.step++;
      },
      openPg() {
        if(!this.selectedItem) {
          this.toast('결제 방식을 선택해주세요.')
          return;
        }
        this.getMerChantId();
      },
      cancel() {
        this.$modal.hide('payPriceModal');
        this.$emit('cancel');
      },
      getData() {
        this.$axios.get('admin/pg_shop').then(res=>{
          this.list = res.data;
          let payPrice = [
            {
              name: 'PG 결제',
              list: [
                {
                  name: '카드결제',
                  type: 'credit',
                  discount: 10,
                  price: 2700000,
                  origin_price: 3000000,
                  selected: false,
                  enable: false
                },
                {
                  name: '실시간 계좌이체',
                  type: 'trans',
                  discount: 10,
                  price: 2700000,
                  origin_price: 3000000,
                  selected: false,
                  enable: false
                },
                {
                  name: '가상계좌',
                  type: 'vbank',
                  discount: 10,
                  price: 3600000,
                  origin_price: 4000000,
                  selected: false,
                  enable: false
                }
              ]
            },
            {
              name: '간편결제',
              list: [
                {
                  name: '네이버페이',
                  type: 'naverpay',
                  discount: 10,
                  price: 4000500,
                  origin_price: 4500000,
                  selected: false,
                  enable: false
                },
                {
                  name: '카카오페이',
                  type: 'kakaopay',
                  discount: 10,
                  price: 3600000,
                  origin_price: 4000000,
                  selected: false,
                  enable: false
                }
              ]
            }
          ]
          payPrice.forEach(item=> {
            item.list.forEach(item2=> {
              let is_item = find(this.list, 'type_en', item2.type)
              if(!is_item) {
                item2.enable = true;
              }
            })
          })
          this.payPrice = payPrice;
          this.selectedTab = this.payPrice[0];
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .price-selected
    border 1px solid #FF5722
    color #FF5722

  .tab-box
    width 85px
    height 32px
    border-radius 3px
    text-align center
    line-height 29px
    font-size 14px
    border 1px solid #cccccc
    background-color white

  .tab-selected
    color #ff5722
    border 1px solid #ff5722
</style>
